import http from '@axios'

const resource = '/api/v1/bank-icon/add-tag'

export default {
  add(icontag) {
    return http.post(`${resource}`, icontag, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}
